import React, { createContext, PropsWithChildren, useState } from "react";

export type Lang = "en" | "id";

interface LocaleContextProps {
  lang: Lang;
  setLang: React.Dispatch<React.SetStateAction<Lang>>;
}

export const LocaleContext = createContext<LocaleContextProps>({
  lang: "en",
  setLang: () => {},
});

export const LocaleProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [lang, setLang] = useState<Lang>("id");

  return (
    <LocaleContext.Provider value={{ lang, setLang }}>
      {children}
    </LocaleContext.Provider>
  );
};
